import { countsService } from '../services';
import * as act from '@/store/documents.actions';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { permissionsHelper } from '@/helpers/permissions.helper';

const state = {
  counters: null,
  balanse: null,
  findString: ''
};

const actions = {
  async [act.ACT_LOADBALANCE]({ commit }) {
    // todo impl doc type filter
    await countsService
      .BalansGet()
      .then(result => {
        commit(act.MUT_ADDBALANCE, { balanse: result.data });
      })
      .catch(_error => {});
  },
  async [act.ACT_LOADCOUNTERS]({ commit }) {
    // todo impl doc type filter
    if (permissionsHelper.isAllowedToViewDocuments) {
      const myOrg = store.getters[_act.ORG_GET_MYORG];
      const myOrgCode = myOrg ? (myOrg.code || '') : '';
      const isOrg = store.getters[_act.SETT_GET_ISSHOWORGDOC];
      await countsService
        .CountersGet(myOrgCode, isOrg)
        .then(result => {
          commit(act.MUT_ADDCOUNTERS, { counters: result.data });
        })
        .catch(_error => {});
    }
  },
  async [act.ACT_SETFINDSTRING]({ dispatch, commit }, { findString }) {
    await commit(act.MUT_SETFINDSTRING, { findString });
  }
};

const mutations = {
  [act.MUT_ADDBALANCE](state: any, { balanse }): void {
    state.balanse = balanse;
  },
  [act.MUT_ADDCOUNTERS](state: any, { counters }): void {
    state.counters = counters;
  },
  [act.MUT_SETFINDSTRING](state: any, { findString }): void {
    state.findString = findString;
  }
};

const getters = {
  [act.GET_COUNTERS]: state => {
    return state.counters;
  },
  [act.GET_BALANCE]: state => {
    return state.balanse;
  },
  [act.GET_FINDSTRING]: state => {
    return state.findString;
  }
};

export const documents = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
